var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx } from "react/jsx-runtime";
import "../TagPicker/index.js";
import { Field } from "./Field.js";
import ___default from "lodash";
import { compareIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
import { TagPicker } from "../TagPicker/TagPicker.js";
class TagPickerField extends Field {
  constructor() {
    super(...arguments);
    __publicField(this, "children", (fieldProps) => {
      const _a = this.props, { tagPickerProps } = _a, rest = __objRest(_a, ["tagPickerProps"]);
      return /* @__PURE__ */ jsx(
        TagPicker,
        __spreadProps(__spreadValues({}, rest), {
          tagPickerProps: __spreadProps(__spreadValues(__spreadValues({}, tagPickerProps), fieldProps.field), {
            onChange: (selectedItems) => this._handleChange(selectedItems, fieldProps),
            /**
             * Disable onBlur
             * Formik will read from the input field value which is empty
             * Instead _handleChange will provide field values including onBlur
             */
            onBlur: () => null,
            selectedItems: this._getSelectedItems(fieldProps, tagPickerProps)
          }),
          errorMessage: fieldProps.meta.touched && fieldProps.meta.error || ""
        })
      );
    });
    __publicField(this, "_getSelectedItems", (fieldProps, tagPickerProps) => {
      var _a, _b;
      const options = tagPickerProps.items || [];
      const selectedKeys = ((_b = (_a = fieldProps == null ? void 0 : fieldProps.field) == null ? void 0 : _a.value) == null ? void 0 : _b.map((item) => item)) || [];
      const selectedOptions = selectedKeys.map((s) => ___default.find(options, (o) => this._compareKeys(o == null ? void 0 : o.key, s)) || { name: s.toString(), key: s }).filter((s) => !!s);
      return selectedOptions;
    });
    __publicField(this, "_compareKeys", (selectedKey, optionKey) => {
      if (selectedKey === optionKey) {
        return true;
      } else {
        return compareIgnoreCase(selectedKey.toString(), optionKey.toString());
      }
    });
    __publicField(this, "_handleChange", (selectedItems, props) => {
      const newItems = (selectedItems || []).map((i) => i.key);
      props.form.setFieldTouched(props.field.name, true);
      props.form.setFieldValue(props.field.name, newItems, true);
    });
  }
}
export {
  TagPickerField
};
//# sourceMappingURL=TagPickerField.js.map
